import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { AuthService } from '../auth.service';

export interface TextSnippet{
  id?: number,
  title: string,
  content?: string
  updatetBy?: number
  updatetAt?: Date
}

@Injectable({
  providedIn: 'root'
})
export class TextmodulesService {

  constructor(
    private http: HttpService,
    private authSrv: AuthService
  ) { }

  public async getAllSnippets(): Promise<HttpFunctionResult<TextSnippet[]>>{
    return await this.http.GET<TextSnippet[]>({
      path: "ticket/text-modules"
    })
  }

  public async getSnippetById(id: number): Promise<HttpFunctionResult<TextSnippet>>{
    return await this.http.GET<TextSnippet>({
      path: `ticket/text-modules/${id}`
    })
  }

  public async deleteSnippet(textModule: TextSnippet): Promise<HttpFunctionResult<any>>{
    return await this.http.DELETE<any>({
      path: `ticket/text-modules/${textModule.id}`
    })
  }

  public async addSnippet(textModule: TextSnippet): Promise<HttpFunctionResult<TextSnippet>>{
    textModule.updatetBy = this.authSrv.getUser()?.id
    return await this.http.POST<TextSnippet, TextSnippet>({
      path: `ticket/text-modules`,
      body: textModule
    })
  }

  public async updateSnippet(textModule: TextSnippet): Promise<HttpFunctionResult<TextSnippet>>{
    return await this.http.PUT<TextSnippet, TextSnippet>({
      path: `ticket/text-modules`,
      body: textModule
    })
  }

  public async updateSort(list: {key: number, value: number}[]){
    return await this.http.PUT<any, [number, number][]>({
      path: "ticket/text-modules/sort",
      body: list
    })
  }
}
